<script>
  import { cart } from '../models/cart.js'
  export let product
  export let subscriptionDetails = null
  export let compact = false

  let added = false
  $: isInCart =
    $cart.some((c) => c.id === product.id) && subscriptionDetails.valid

  async function addItem(product) {
    let success = cart.addSubscriptionRental(product)
    if (success) {
      added = true
    }

    if (added) {
      setTimeout(() => {
        added = false
      }, 2500)
    }
  }
</script>

<style>

</style>

{#if added}
  <p class="cart-success">
    <svg class="icon">
      <use href="/icons.svg#check" />
    </svg>
    Added to Cart!
  </p>
{:else if isInCart}
  <button
    class="btn btn-expanded"
    class:btn-plain={compact}
    on:click={cart.remove(product)}>
    <svg class="icon">
      <use href={'/icons.svg#clear'} />
    </svg>
    Remove from Cart
  </button>
{:else if product.in_stock > 0 && product.active}
  {#if subscriptionDetails.hasSubscription && subscriptionDetails.valid}
    <button
      class="btn btn-expanded"
      class:btn-plain={compact}
      on:click={() => addItem(product)}>
      <svg class="icon">
        <use href={'/icons.svg#cart'} />
      </svg>
      Rent now!
    </button>
  {:else if subscriptionDetails.hasSubscription && !subscriptionDetails.valid}
    <button class="btn" disabled={true}>
      {subscriptionDetails.validErrMessage}
    </button>
  {:else}
    <h4 class="h4">Choose A Subscription Plan</h4>
    <p>
      By becoming a Puzzle Exchange subscription member, rent more puzzles
      without worrying about late fees.
    </p>
    <button
      class="btn"
      on:click={() => (window.location.href = '/ways-to-rent')}>
      Browse Subscription Plans
    </button>
  {/if}
{:else}
  <button class="btn" class:btn-plain={compact} disabled={true}>
    Out of Stock
  </button>
{/if}
